module.exports = __webpack_public_path__ + "img/regions-logo.188c43a2.jpg";